import * as React from "react";
import { MobileMenuItem } from "./MobileMenuItem";
import {
  IMobileMenuLevelProps,
  IMobileMenuLevelState,
} from "./MobileMenuLevel.types";
import { MenuItem } from "./MobileMenu.types";

export class MobileMenuLevel extends React.Component<
  IMobileMenuLevelProps,
  IMobileMenuLevelState
> {
  constructor(props: IMobileMenuLevelProps) {
    super(props);
  }

  private renderMenuItems = (menuItem: MenuItem) => {
    return (
      <MobileMenuItem
        language={this.props.language}
        menuItem={menuItem}
        setActiveMenuItemCallback={this.props.setActiveMenuItemCallback}
        addChildrenToTreeCallback={this.props.addChildrenToTreeCallback}
        key={menuItem.Id}
        isStartPage={this.props.isStartPage}
      />
    );
  };

  public render() {
    return (
      <ul className="mobile-menu__menu-item-list">
        {this.props.activeMenuItem &&
          this.props.activeMenuItem.Children.map(this.renderMenuItems)}
      </ul>
    );
  }
}
